import { Building02 } from '@/components/common/icons';
import { Box, BoxProps } from '@chakra-ui/react';
import { MerchantFieldsFragment } from '@common/graphql/generated';

interface Props extends BoxProps {
    merchant?: Pick<MerchantFieldsFragment, 'logoUrl'> | null;
    width?: number;
}
const MerchantLogo = ({ merchant, width = 6, ...props }: Props) => {
    if (!merchant?.logoUrl) {
        return (
            <Box {...props} w={width}>
                <Building02 color="gray.500" size="md" w={6} ml={0.5} />
            </Box>
        );
    }

    return (
        <Box
            {...props}
            minW={width}
            w={width}
            h={width}
            borderRadius="full"
            bg={`url('${merchant.logoUrl}') 50% 50%/cover no-repeat`}
        />
    );
};

export default MerchantLogo;
